import {
    XAxis,
    YAxis,
    Tooltip as ReChartsTooltip,
    Area,
    ComposedChart,
    ResponsiveContainer, AreaChart, Line, Legend, LineChart, ReferenceLine, CartesianGrid
} from 'recharts';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    bbDangerousStringToDate,
    bbErrorSection, bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor
} from "../../../util/bbHelpers";
import React from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Badge} from "reactstrap";
import {useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";
import BRFidelityBadge from "../BRPortfolio/BRFidelityBadge";
import {history} from "../../../store";

// const testData = [
//     {
//         cycle: "123123",
//         cycle_date: '2021-05-02 16:28:17',
//         score: 4.1,
//         confidence_lower: 3.2,
//         confidence_upper: 5.2,
//     },
//     {
//         cycle: "1231234",
//         cycle_date: '2021-06-02 16:28:17',
//         score: 3.0,
//         confidence_lower: 2.2,
//         confidence_upper: 4.2,
//     },
//     {
//         cycle: "1231235",
//         cycle_date: '2021-07-02 16:28:17',
//         score: 2.0,
//         confidence_lower: 1.2,
//         confidence_upper: 3.4,
//     },
//     {
//         cycle: "1231236",
//         cycle_date: '2021-08-02 16:28:17',
//         score: 2.7,
//         confidence_lower: 1.9,
//         confidence_upper: 3.9,
//     },
//     {
//         cycle: "1231237",
//         cycle_date: '2021-09-02 16:28:17',
//         score: 1.8,
//         confidence_lower: 0.3,
//         confidence_upper: 2.2,
//     },
//     {
//         cycle: "1231237",
//         cycle_date: '2021-10-02 16:28:17',
//         score: 4.5,
//         confidence_lower: 3.1,
//         confidence_upper: 8.8,
//     },
//     {
//         cycle: "1231238",
//         cycle_date: '2021-11-02 16:28:17',
//         score: 6.8,
//         confidence_lower: 4.2,
//         confidence_upper: 8.9,
//     },
// ];
//
// function getIntroOfPage(label) {
//     if (label === 'Page A') {
//         return "'Page A is about men's clothing'";
//     }
//     if (label === 'Page B') {
//         return "'Page B is about men's clothing'";
//     }
// }


function CustomTooltip({ payload, label, active }) {
    // console.log("tip payload is", payload)
    if (active && payload) {
        const isTheNeutralDataPoint = payload[0].payload.isTheNeutralDataPoint; //this data point is special
        const brAverage = payload[0].payload.averageBRScore;
        return (
            <Widget styleName={`p-1 px-2`}>
                <h3><em>{isTheNeutralDataPoint ? `Before your first BreachRisk™ Score` : `${bbFormattedDateString(label, "shortFullMonth")}`}</em></h3>
                <h1 className="label">{isTheNeutralDataPoint ? `Neutral start: ${parseFloat(payload[0].value).toFixed(1)}` : `BreachRisk™ Score: ${parseFloat(payload[0].value).toFixed(1)}`}</h1>
                {isTheNeutralDataPoint && <h4><em>All companies start with a neutral BreachRisk™ Score of 5.0.</em></h4>}

                {/*<h4 className={"text-center"}>Risk Category:</h4>*/}


                {!isTheNeutralDataPoint &&  <Badge color={bbTranslateBreachRiskScoreToColor(parseFloat(payload[0].value).toFixed(1))}><span style={{fontSize: "larger"}}>{bbTranslateBreachRiskScoreToCategory(parseFloat(payload[0].value).toFixed(1))} Risk</span></Badge> }

                <hr/>
                <p>
                    {/*<Badge color={bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor(parseFloat(payload[0].payload.confidence_low).toFixed(1), parseFloat(payload[0].payload.confidence_high).toFixed(1))}>*/}
                    {/*    {bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(parseFloat(payload[0].payload.confidence_low).toFixed(1), parseFloat(payload[0].payload.confidence_high).toFixed(1))}*/}
                    {/*</Badge>*/}
                    <BRFidelityBadge cycleObject={payload[0].payload}/> <em>Risk could be: <strong>{parseFloat(payload[0].payload.confidence_low).toFixed(1)}</strong> - <strong>{parseFloat(payload[0].payload.confidence_high).toFixed(1)}</strong></em></p>

                {/*<p className="intro">{getIntroOfPage(label)}</p>*/}
                {/*<p className="desc">Anything you want can be displayed here.</p>*/}
                <h3>{`Global Average BreachRisk™ Score: ${parseFloat(brAverage).toFixed(1)}`}<small className={"text-gray"}>/10</small></h3>
            </Widget>
        );
    }

    return null;
}

const bbTickFormatter = (input) => {
    return bbFormattedDateString(input, 'micro');
}

const RenderLineChart = ({
                             showVectorRiskScore = false,
                             showFidelity = false,
                         }
    ) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const portfolioAverages = portfolios && customerIdToUse && portfolios[customerIdToUse] &&  portfolios[customerIdToUse].averages;
    const averageBRScore = portfolioAverages && portfolioAverages["breachrisk_average"];

    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    let historyData = myEntity ? myEntity.history : null;

    //add the average line
    //go through each part and add  averageBRScore: averageBRScore, to the object
    const historyDataWithAverageLineData = historyData && historyData.map(dataPoint => {

        return {
            ...dataPoint,
            averageBRScore: averageBRScore
        }
    });
    // console.log("Added the BR average to the BreachRiskScoreLineChart data", historyDataWithAverageLineData);
    const sortedHistoryData = historyDataWithAverageLineData ? historyDataWithAverageLineData.sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1)) : null;

    //only show the 10 most recent data points
    const totalNumDataPoints = sortedHistoryData ? sortedHistoryData.length : null;
    const numDataPointsToShow = 10;
    if(totalNumDataPoints && totalNumDataPoints > numDataPointsToShow) {
        const numPointsToRemove = totalNumDataPoints - numDataPointsToShow;
        const removedHistoryData = sortedHistoryData.splice(0, numPointsToRemove);
    }


    // console.log("sortedHistoryData", sortedHistoryData);

    // let newHistoryReferenceArea = null;

    //if history data is too small, add a point to the front
    // if (historyData && historyData.length < 2 && historyData[0]) {
    //     let copyThisPoint = historyData[0];
    //     // copyThisPoint.cycle_date = (bbDangerousStringToDate(historyData[0].cycle_date) - 31)
    //     historyData = [copyThisPoint].concat(historyData);
    //     historyData = [copyThisPoint].concat(historyData);
    //
    //     newHistoryReferenceArea = <ReferenceArea label = "Unknown Risk Level" x1={bbTickFormatter(copyThisPoint.cycle_date)} x2={bbTickFormatter(historyData[historyData.length - 1].cycle_date)} y1={0} y2={10} stroke="red" strokeOpacity={0.3} />
    // }

    //if there are fewer than 8 data points, put one in the front starting at 5.0 neutral so there are always at least 2 data points and it shows them that without looking we assume a 5.0
    if(sortedHistoryData && sortedHistoryData.length < 8 && sortedHistoryData[0] && !sortedHistoryData[0].isTheNeutralDataPoint) {
        // console.log("Fewer than 8 datapoints detected, adding helper neutral data point for context.", sortedHistoryData)
        // const earliestRealDate = sortedHistoryData[0].cycle_date
        const neutralDataPoint = {
            confidence_high: 10,
            confidence_low: 0,
            cycle: null,
            cycle_date: null,
            score: 5,
            isTheNeutralDataPoint: true,
            averageBRScore: averageBRScore,
        };
        sortedHistoryData.unshift(neutralDataPoint)

    }


    return <Widget styleName={`p-2 animated fadeIn animation-duration-5 dataTile tourBRScoreHistoryWidget`}>
        <Tooltip disableFocusListener
                 title={"How your BreachRisk™ Score - your risk of a breach - has changed over time. Lower scores are better."}>
            <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                           className={`text-muted`}/>
        </Tooltip>
        <div className="row tourBRScoreHistoryWidget">
            <div className={"col-12"}>


            </div>
        </div>
        <div className="row " style={{height: 250}}>
            <div className={"col-9 "}>
                {!portfolios || loadingPortfolios[customerIdToUse] ?
                    <Skeleton count={10}/>
                    : !myEntity || loadingPortfoliosError[customerIdToUse] ?
                        <div className={"text-center"}>
                            {bbErrorSection("80px")}
                        </div>
                        :
                            <ResponsiveContainer>
                                <LineChart width={800} height={250} data={sortedHistoryData}
                                               margin={{top: 1, right: 10, left: 2, bottom: 5}}>
                                    {/*<Area type="monotone" dataKey="confidence_upper" stroke="#999999" />*/}
                                    <defs>
                                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                            {/*{//TODO:implement gradient colors based on the highest value}*/}
                                            {/*<stop offset="0%" stopColor="#F6101F" stopOpacity={0.5}/>*/}
                                            {/*<stop offset="20%" stopColor="#F28722" stopOpacity={0.5}/>*/}
                                            {/*<stop offset="40%" stopColor="#EDEA34" stopOpacity={0.5}/>*/}
                                            {/*<stop offset="60%" stopColor="#5FBA15" stopOpacity={0.4}/>*/}
                                            {/*<stop offset="80%" stopColor="#00863B" stopOpacity={0.3}/>*/}
                                            {/*<stop offset="98%" stopColor="#00863B" stopOpacity={0.1}/>*/}

                                            <stop offset="5%" stopColor="#69A5FF" stopOpacity={0.8}/>
                                            <stop offset="95%" stopColor="#69A5FF" stopOpacity={0}/>
                                        </linearGradient>
                                    </defs>
                                    {/*{newHistoryReferenceArea &&*/}
                                    {/*<ReferenceArea label = "Unknown Risk Level" x1={bbTickFormatter(historyData[0].cycle_date)} x2={bbTickFormatter(historyData[historyData.length - 1].cycle_date)} y1={0} y2={10} stroke="red" strokeOpacity={0.3} />*/}
                                    {/*}*/}
                                    {/*<ReferenceArea label = "High Risk" x1={"May"} x2={"Nov"} y1={6} y2={10} stroke="red" strokeOpacity={0.3} />*/}
                                    {/*<ReferenceArea label = "High Risk" x1={"May"} x2={"Nov"} y1={6} y2={8} stroke="orange" strokeOpacity={0.3} />*/}
                                    {/*<Area type="monotone" dataKey="score" stroke="#8884d8" strokeWidth={5} dot={{stroke: 'blue', strokeWidth: 0}}*/}
                                    {/*      fillOpacity={1} fill="url(#colorUv)">*/}
                                    {/*    /!*<ErrorBar dataKey="confidence_upper" width={4} strokeWidth={2} stroke="green" direction="y" />*!/*/}
                                    {/*</Area>*/}
                                    <CartesianGrid stroke="#eff9ef" />
                                    <Line type="monotone" name="BreachRisk™ Score"
                                          dataKey="score" stroke="#69A5FF" strokeWidth={7} >

                                        {/*<ErrorBar dataKey="confidence_high" width={4} strokeWidth={2} stroke="green" direction="y" />*/}
                                    </Line>
                                    {showFidelity &&
                                        <Line type="monotone" name="Possible Low"  dataKey="confidence_low" stroke="green" />
                                    }
                                    {showFidelity &&
                                        <Line type="monotone" name="Possible High" dataKey="confidence_high" stroke="red" />
                                    }
                                    {/*<Line type="monotone" dataKey="confidence_high" stroke="#aaaaaa" />*/}
                                    {/*<Line type="monotone" dataKey="confidence_low" stroke="#aaaaaa" />*/}
                                    {/*<Area type="monotone" dataKey="confidence_lower" stroke="#7784e8" />*/}


                                    {/*{averageBRScore &&*/}
                                    {/*    <ReferenceLine isFront y={averageBRScore} strokeWidth={3} stroke="black" strokeDasharray="5 5" label={{ position: 'top',  value: `Global Average`, fill: 'black', fontSize: 20 }} />*/}
                                    {/*}*/}

                                    {averageBRScore &&
                                        <Line type="monotone" name="Global Average BreachRisk™ Score" dataKey="averageBRScore" stroke="black" strokeDasharray="5 5" />

                                        // <ReferenceLine isFront y={averageBRScore} strokeWidth={3} stroke="black" strokeDasharray="5 5" label={{ position: 'top',  value: `Global Average`, fill: 'black', fontSize: 20 }} />
                                    }


                                    <ReChartsTooltip content={<CustomTooltip/>}/>
                                    <XAxis dataKey="cycle_date" tickFormatter={bbTickFormatter}/>
                                    <YAxis domain={[0, 10]} ticks={[2, 4, 6, 8, 10]} />
                                    <Legend verticalAlign={"bottom"}/>

                                </LineChart>
                            </ResponsiveContainer>
                }
            </div>
            <div className={"col-3"}>
                <div className="text-center">
                    <h1>BreachRisk™ Score History</h1>

                </div>
                <p>Cyber attackers get better every day. Risk can change over time based on several factors, including
                    new attacker capabilities, changes in defense, and as we discover weaknesses.</p>

            </div>
        </div>

    </Widget>
};

export default RenderLineChart;